import React, { useState, useEffect } from "react";
import {
  FaUserCircle,
  FaKey,
  FaUserAlt,
  FaRegUser,
  FaRegEnvelope,
  FaPhone,
  FaUnlock,
  FaTimes,
  FaCheck,
  FaInfoCircle,
} from "react-icons/fa";
import SyncLoader from "react-spinners/SyncLoader";
import axios from "../../../../../api/axios";
import validator from "validator";
import profile from "../../../../../images/profile.png";
import DashMenu from "../../../../atoms/DashMenu/DashMenu";
import "./Edit.css";
import SubHeader from "../../../../atoms/SubHeader/SubHeader";

const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;

const Edit = ({ toggleMenu, showMenu }) => {
  let EDIT_URL = "/user/update/profile/";

  const [username, setUsername] = useState("");
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [matchPwd, setMatchPwd] = useState(false);
  const [userFocus, setUserFocus] = useState(false);
  const [matchFocus, setMatchFocus] = useState(false);
  const [validName, setValidName] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [validMatch, setValidMatch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [preview, setPreview] = useState("");
  const [profileImage, setProfileImage] = useState(null);

  useEffect(() => {
    if (profileImage && typeof profileImage !== "string") {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(profileImage);
    } else {
      setPreview(null);
    }
  }, [profileImage]);

  useEffect(() => {
    setValidName(USER_REGEX.test(username));
  }, [username]);

  useEffect(() => {
    setValidMatch(password === matchPwd);
  }, [password, matchPwd]);

  useEffect(() => {
    setErrMsg("");
  }, [username, password, matchPwd]);

  const checkInputs = () => {
    if (!validator.isEmail(email)) {
      setErrMsg("Invalid Email Address");
      return;
    }
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    let config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        'Access-Control-Allow-Origin': '*',
      },
    };
    checkInputs();
    // if button enabled with JS hack
    const v1 = USER_REGEX.test(username);
    if (!v1) {
      setErrMsg("Invalid Entry");
      return;
    }

    if (password.length < 8) {
      setErrMsg("Password must not be less than 8 characters");
      setIsLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("first_name", firstname);
    formData.append("username", username);
    formData.append("last_name", lastname);
    formData.append("password", password);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("profile_image", profileImage);

    try {
      const response = await axios.post(EDIT_URL, formData, config);
      console.log(response?.data);
      console.log(response?.accessToken);
      console.log(JSON.stringify(response));
      // navigate("/account-success");
      //clear state and controlled inputs
      //need value attrib on inputs for this
      setUsername("");
      setPassword("");
      setMatchPwd("");
      setEmail("");
      setFirstName("");
      setLastName("");
      setProfileImage(null);
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.status === 409) {
        setErrMsg("Username Taken");
      } else {
        setErrMsg("Registration Failed");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="dashboard-home-wrapper">
      <div className="dashmenu-style">
        <DashMenu toggleMenu={toggleMenu} showMenu={showMenu} />
      </div>{" "}
      <SubHeader title={"EDIT"} />
      <div className="dash-edit-content-wrapper">
        <div className="edit-box edit-box1">
          <div className="edit-box-header">
            <FaUserCircle className="userprofile" />
            <h3>Change Avatar</h3>
          </div>
          <div className="edit-box-bg">
            <div className="edit-bg-1">
              <label for="myfile" className="profile">
                {preview ? <img src={preview} className='profile-img' alt="" /> : <img src={profile} alt="" />}
              </label>
              <p>Upload New Photo</p>
              <input
                type="file"
                id="myfile"
                name="myfile"
                onChange={(e) => setProfileImage(e.target.files[0])}
              />
            </div>
          </div>
        </div>
        <div className="edit-box edit-box3">
          <form onSubmit={(e) => handleSubmit(e)}>
            <div className="edit3-header">
              <FaKey className="userprofile" />
              <h3>Personal Info</h3>
            </div>
            <p
              className={errMsg ? "errmsg" : "offscreen"}
              arial-live="assertive"
            >
              {errMsg}
            </p>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">
                  Username *{" "}
                  <FaCheck className={validName ? "valid" : "hide"} />
                  <FaTimes
                    className={validName || !username ? "hide" : "invalid"}
                  />
                </label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaUserAlt className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="username"
                    onChange={(e) => setUsername(e.target.value)}
                    value={username}
                    arial-invalid={validName ? "false" : "true"}
                    arial-describeby="uidnote"
                    required
                    placeholder="Your Username"
                    onFocus={() => setUserFocus(true)}
                    onBlur={() => setUserFocus(false)}
                  />
                  <p
                    id="uidnote"
                    className={
                      userFocus && username && !validName
                        ? "instructions"
                        : "offscreen"
                    }
                  >
                    <FaInfoCircle />
                    4 to 24 characters.
                    <br />
                    Must begin with a letter.
                    <br />
                    Letters, numbers, underscores, hyphens allowed.
                  </p>
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">First Name *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaRegUser className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="firstname"
                    onChange={(e) => setFirstName(e.target.value)}
                    value={firstname}
                    required
                    placeholder="Your Firstname"
                  />
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">Last Name *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaUserAlt className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="lastname"
                    onChange={(e) => setLastName(e.target.value)}
                    value={lastname}
                    required
                    placeholder="Your Lastname"
                  />
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">Email *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaRegEnvelope className="userprofile" />
                  </div>
                  <input
                    type="email"
                    id="email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    required
                    placeholder="Your Email"
                  />{" "}
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">Phone Number *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaPhone className="userprofile" />
                  </div>
                  <input
                    type="tel"
                    id="phone"
                    onChange={(e) => setPhone(e.target.value)}
                    value={phone}
                    required
                    name="telphone"
                    maxLength="11"
                    placeholder="Phone Number"
                  />
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">Password *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaUnlock className="userprofile" />
                  </div>
                  <input
                    type="password"
                    id="password"
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                    required
                    placeholder="Your Password"
                    aria-describedby="pwdnote"
                  />
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">
                  Confirm Password *
                  <FaCheck
                    className={validMatch && matchPwd ? "valid" : "hide"}
                  />
                  <FaTimes
                    className={validMatch || !matchPwd ? "hide" : "invalid"}
                  />
                </label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaUnlock className="userprofile" />
                  </div>
                  <input
                    type="password"
                    id="pwd"
                    onChange={(e) => setMatchPwd(e.target.value)}
                    required
                    placeholder="Confirm Password"
                    aria-invalid={validMatch ? "false" : "true"}
                    aria-describedby="confirmnote"
                    onFocus={() => setMatchFocus(true)}
                    onBlur={() => setMatchFocus(false)}
                  />
                  <p
                    id="confirmnote"
                    className={
                      matchFocus && !validMatch ? "instructions" : "offscreen"
                    }
                  >
                    <FaInfoCircle />
                    Must match the first password input field.
                  </p>
                </div>
              </div>
            </div>
            {isLoading ? (
              <div className="loading">
                <SyncLoader color={"#098FD2"} loading={isLoading} size={10} />
              </div>
            ) : (
              <button type="submit" className="save-changes">
                Save Changes
              </button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Edit;
